"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginScene = void 0;
const scene_1 = require("@babylonjs/core/scene");
const math_vector_1 = require("@babylonjs/core/Maths/math.vector");
const math_color_1 = require("@babylonjs/core/Maths/math.color");
const freeCamera_1 = require("@babylonjs/core/Cameras/freeCamera");
const advancedDynamicTexture_1 = require("@babylonjs/gui/2D/advancedDynamicTexture");
const rectangle_1 = require("@babylonjs/gui/2D/controls/rectangle");
const textBlock_1 = require("@babylonjs/gui/2D/controls/textBlock");
const control_1 = require("@babylonjs/gui/2D/controls/control");
const button_1 = require("@babylonjs/gui/2D/controls/button");
const inputText_1 = require("@babylonjs/gui/2D/controls/inputText");
const inputPassword_1 = require("@babylonjs/gui/2D/controls/inputPassword");
const image_1 = require("@babylonjs/gui/2D/controls/image");
const Screens_1 = __importDefault(require("./Screens"));
class LoginScene {
    constructor() {
        this._loadedAssets = [];
        this._newState = Screens_1.default.NULL;
    }
    createScene(game) {
        return __awaiter(this, void 0, void 0, function* () {
            // app
            this._game = game;
            // create scene
            let scene = new scene_1.Scene(this._game.engine);
            // set scene
            this._scene = scene;
            // set sky color
            this._scene.clearColor = new math_color_1.Color4(0.1, 0.1, 0.1, 1);
            //creates and positions a free camera
            let camera = new freeCamera_1.FreeCamera("camera1", new math_vector_1.Vector3(0, 0, 0), this._scene);
            camera.setTarget(math_vector_1.Vector3.Zero()); //targets the camera to scene origin
            // create ui
            const guiMenu = advancedDynamicTexture_1.AdvancedDynamicTexture.CreateFullscreenUI("UI");
            this.create(guiMenu);
            // hide loading gui
            this._game.engine.hideLoadingUI();
        });
    }
    create(guiMenu) {
        // middle columm
        const columnRect = new rectangle_1.Rectangle("column");
        columnRect.width = this._game.config.UI_SIDEBAR_WIDTH;
        columnRect.height = 1;
        columnRect.background = "#000000";
        columnRect.thickness = 0;
        columnRect.horizontalAlignment = control_1.Control.HORIZONTAL_ALIGNMENT_CENTER;
        guiMenu.addControl(columnRect);
        // logo
        var imgLogo = new image_1.Image("imgLogo", "./images/logo.png");
        imgLogo.stretch = image_1.Image.STRETCH_UNIFORM;
        imgLogo.top = "30px";
        imgLogo.width = 1;
        imgLogo.height = "75px;";
        imgLogo.verticalAlignment = control_1.Control.VERTICAL_ALIGNMENT_TOP;
        columnRect.addControl(imgLogo);
        // welcome text
        const welcomeText = new textBlock_1.TextBlock("infotext", this._game.config.version);
        welcomeText.width = 0.8;
        welcomeText.height = "40px";
        welcomeText.color = "white";
        welcomeText.top = "120px";
        welcomeText.horizontalAlignment = control_1.Control.HORIZONTAL_ALIGNMENT_CENTER;
        welcomeText.verticalAlignment = control_1.Control.VERTICAL_ALIGNMENT_TOP;
        columnRect.addControl(welcomeText);
        // FORM CONTAINER columm
        const formContainer = new rectangle_1.Rectangle("formContainer");
        formContainer.width = 1;
        formContainer.height = "300px";
        formContainer.thickness = 0;
        formContainer.horizontalAlignment = control_1.Control.HORIZONTAL_ALIGNMENT_CENTER;
        formContainer.verticalAlignment = control_1.Control.VERTICAL_ALIGNMENT_BOTTOM;
        columnRect.addControl(formContainer);
        ///////////////////////////////////////////
        // username input
        const usernameInput = new inputText_1.InputText("usernameInput");
        usernameInput.top = "-140px";
        usernameInput.width = 0.8;
        usernameInput.height = "30px;";
        usernameInput.color = "#FFF";
        usernameInput.text = "";
        //usernameInput.text = "test";
        usernameInput.placeholderText = "Enter username";
        usernameInput.horizontalAlignment = control_1.Control.HORIZONTAL_ALIGNMENT_CENTER;
        usernameInput.verticalAlignment = control_1.Control.VERTICAL_ALIGNMENT_BOTTOM;
        formContainer.addControl(usernameInput);
        usernameInput.onKeyboardEventProcessedObservable.add((ev) => {
            if (ev.key === "Tab") {
                guiMenu.focusedControl = passwordInput;
                ev.preventDefault();
            }
        });
        ///////////////////////////////////////////
        // password input
        const passwordInput = new inputPassword_1.InputPassword("passwordInput");
        passwordInput.width = 0.8;
        passwordInput.height = "30px;";
        passwordInput.color = "#FFF";
        passwordInput.top = "-110px";
        passwordInput.text = "";
        passwordInput.placeholderText = "Enter password";
        passwordInput.horizontalAlignment = control_1.Control.HORIZONTAL_ALIGNMENT_CENTER;
        passwordInput.verticalAlignment = control_1.Control.VERTICAL_ALIGNMENT_BOTTOM;
        formContainer.addControl(passwordInput);
        passwordInput.onKeyboardEventProcessedObservable.add((ev) => {
            if (ev.key === "Enter") {
                this.login(usernameInput.text, passwordInput.text);
                usernameInput.text = "";
                passwordInput.text = "";
            }
        });
        ///////////////////////////////////////////
        // login button
        const joinBtn = button_1.Button.CreateSimpleButton("back", "Connect To Game");
        joinBtn.width = 0.8;
        joinBtn.height = "30px";
        joinBtn.color = "white";
        joinBtn.top = "-80px";
        joinBtn.thickness = 1;
        joinBtn.horizontalAlignment = control_1.Control.HORIZONTAL_ALIGNMENT_CENTER;
        joinBtn.verticalAlignment = control_1.Control.VERTICAL_ALIGNMENT_BOTTOM;
        formContainer.addControl(joinBtn);
        joinBtn.onPointerDownObservable.add(() => __awaiter(this, void 0, void 0, function* () {
            yield this.login(usernameInput.text, passwordInput.text);
            // reset input
            usernameInput.text = "";
            passwordInput.text = "";
        }));
        ///////////////////////////////////////////
        // guest button
        const joinGuestBtn = button_1.Button.CreateSimpleButton("joinGuestBtn", "Quick Play");
        joinGuestBtn.width = 0.8;
        joinGuestBtn.height = "30px";
        joinGuestBtn.color = "white";
        joinGuestBtn.top = "-30px";
        joinGuestBtn.thickness = 1;
        joinGuestBtn.horizontalAlignment = control_1.Control.HORIZONTAL_ALIGNMENT_CENTER;
        joinGuestBtn.verticalAlignment = control_1.Control.VERTICAL_ALIGNMENT_BOTTOM;
        formContainer.addControl(joinGuestBtn);
        joinGuestBtn.onPointerDownObservable.add(() => __awaiter(this, void 0, void 0, function* () {
            this._game.setScene(Screens_1.default.CHARACTER_SELECTION);
        }));
        // load scene
        this._ui = guiMenu;
    }
    login(username, password) {
        return __awaiter(this, void 0, void 0, function* () {
            let loginResult = yield this._game.login(username, password);
            if (loginResult) {
                this._game.setScene(Screens_1.default.CHARACTER_SELECTION);
            }
        });
    }
}
exports.LoginScene = LoginScene;
